export default "/images/5e694c721070f36e118776e783c33815.avif";